import React, { useEffect, useState } from "react";
import './Portfolio.css';
import PrimeryButton from '../../ControlledComponents/PrimeryButton/PrimeryButton';
import surviveImage from '../../Assets/portfolio/survival-story-image.png'
import documenteryImage from '../../Assets/portfolio/documentery-image.png'
import videoGRaphyImage from '../../Assets/portfolio/video-graphy.png';
import interviewImage from '../../Assets/portfolio/interview.png';
// Images
import img1 from "../../Assets/recent-projects/recent-1.jpeg";
import img2 from "../../Assets/recent-projects/eid.png";
import img3 from "../../Assets/recent-projects/recent-3.jpg";
import img4 from "../../Assets/recent-projects/recent-4.jpeg";
import img5 from "../../Assets/recent-projects/Danger of the Spear Branch... Yemen.jpg";
import img6 from "../../Assets/recent-projects/Omicron and fair vaccine distribution.jpg";
import img7 from "../../Assets/recent-projects/Suffering Of Yemeni Refuge.jpg";
import img8 from "../../Assets/recent-projects/The Poetic Image in Khalil Hawi.jpg";
import img9 from "../../Assets/recent-projects/You made us happy, Eid.. Yemen.jpg"
import img10 from "../../Assets/recent-projects/Death Belt.jpg";
import img11 from "../../Assets/recent-projects/KhaṭarGhusn.png";
import img12 from "../../Assets/recent-projects/Oud.png";
import img14 from "../../Assets/recent-projects/redcarpet.png";
import img15 from "../../Assets/recent-projects/SW.png";
import img16 from "../../Assets/recent-projects/HOR.png";
import img17 from "../../Assets/recent-projects/ruman.png";
import img18 from "../../Assets/recent-projects/blueye.png";
import img19 from "../../Assets/recent-projects/ghouta.png";
import img20 from "../../Assets/recent-projects/gag.png";
import img21 from "../../Assets/recent-projects/ArtandPoltics.png";
import img22 from "../../Assets/recent-projects/rumi.png";
import img23 from "../../Assets/recent-projects/presions.png";
import img24 from "../../Assets/recent-projects/familyJoy.png";
import img25 from "../../Assets/recent-projects/clinic.png";
import img26 from "../../Assets/recent-projects/orientradio.png";
import img27 from "../../Assets/recent-projects/orientfire.png";
import img28 from "../../Assets/recent-projects/showreel.png";
import img29 from "../../Assets/recent-projects/logopromo.png";
import img30 from "../../Assets/recent-projects/orientraning.png";
import img31 from "../../Assets/recent-projects/freesyria.png";
import img32 from "../../Assets/recent-projects/nahhat.png";
import img33 from "../../Assets/recent-projects/ramadan.png";
import img34 from "../../Assets/recent-projects/finco1.png";
import img35 from "../../Assets/recent-projects/finco2.png";
import img36 from "../../Assets/recent-projects/syriapromo.png";
import img37 from "../../Assets/recent-projects/serum.png";
import img38 from "../../Assets/recent-projects/clip.png";
import { useTranslation } from "react-i18next";


// import ContactForm from '../../Components/ContactForm/ContactForm';
import ProductCategories from '../../Components/ProductCategory/ProductCategories';
import SingleProject from '../../Components/SingleProject/SingleProject';
import ReadyToAsk from '../../GlobalComponents/ReadyToAsk/ReadyToAsk';
import Button4 from '../../GlobalComponents/button3';
import { AiFillFire } from "react-icons/ai";
import { useNavigate } from 'react-router-dom';
import SEO from '../../Components/SEO';

const Portfolio = () => {
  const { t ,i18n} = useTranslation();
   const rawItems = t('allprojects1.items', { returnObjects: true });
  const [selectedCategory, setSelectedCategory] = useState("All");
  const translatedItems = Object.values(rawItems);
  

  const singleProject = [
    { img: img1, videoId: '737099444' },
    { img: img3, videoId: '489755949' },
    { img: img4, videoId: '225090240' },
    { img: img2, videoId: '737117181' },
    { img: img5, videoId: '737094694' },
    { img: img6, videoId: '737868048' },
    { img: img7, videoId: '737285335' },
    { img: img8, videoId: '515248839' },
    { img: img9, videoId: '702870489' },
    { img: img10, videoId: '391779086' },
    { img: img12, videoId: '491200892' },
    { img: img14, videoId: '140050820' },
    { img: img15, videoId: '138086222' },
    { img: img16,  videoId: '161357620' },
    { img: img17, videoId: '137948750' },
    { img: img18,  videoId: '139842849' },
    { img: img19,  videoId: '139842403' },
    { img: img20,  videoId: '148217001' },
    { img: img21,  videoId: '197181783' },
    { img: img22,  videoId: '171202790' },
    { img: img23,  videoId: '765412257' },
    { img: img24, videoId: '700207899' },
    { img: img25, videoId: '518533318' },
    { img: img26,  videoId: '138087194' },
    { img: img27,  videoId: '559601455' },
    { img: img28,  videoId: '512417365' },
    { img: img29,  videoId: '582904854' },
    { img: img30,  videoId: '174486295' },
    { img: img31, videoId: '582906770' },
    { img: img32, videoId: '582905877' },
    { img: img33, videoId: '179038853' },
    { img: img34, videoId: '491617549' },
    { img: img35, videoId: '491611253' },
    { img: img36, videoId: '491611253' },
    { img: img37, videoId: '508759252' },
    { img: img38, videoId: '11692194' },
  ];
   const mappedStories = translatedItems.map((item, index) => ({
        ...item,
        ...singleProject[index] 
    }));

  const filteredProjects =
    selectedCategory === t("categories.links.All")
      ? mappedStories
      : mappedStories.filter((p) => p.tag === selectedCategory);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    return (
       <>
         <SEO 
      title="Projects - Filmarz" 
      description="Filmarz" 
      keywords="art, productions" 
      author="Three Mean"
  />
      <div className="project-main-container">
        {/* CATEGORY BAR */}
        <ProductCategories
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />

        {/* PROJECT GRID */}
        <div className="projects-display">
          {filteredProjects.map((p, idx) => (
            <SingleProject
              key={idx}
              tag={p.tag}
              projectImage={p.img}
              chanelName={p.chanel}
              projectTitle={p.projectTitle}
              vimeoId={p.videoId}
            />
          ))}
        </div>

        <ReadyToAsk />
      </div>
    </>
  );
};

export default Portfolio;
